import { combineReducers, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Logic, createLogicMiddleware } from 'redux-logic';

import { searchCustomersReducer } from './searchCustomers/reducer';
import { searchCustomersLogic } from './searchCustomers/logics';
import { contextReducer } from './context/reducer';
import { fetchContextLogic } from './context/logics';
import {
  addCustomerToSaleLogic,
  getCustomerLogic,
  removeCustomerFromSaleLogic,
  createLoyaltyAccountLogic,
} from './customer/logics';
import { customerReducer } from './customer/reducer';
import { discountsReducer } from './discounts/reducer';
import {
  addDiscountLogic,
  clearDiscountsLogic,
  fetchDiscountsLogic,
  removeDiscountLogic,
  removeDiscountsLogic,
} from './discounts/logics';
import { barcodeScannerReducer } from './barcodeScanner/reducer';

export const rootReducer = combineReducers({
  barcodeScanner: barcodeScannerReducer,
  context: contextReducer,
  customer: customerReducer,
  discounts: discountsReducer,
  searchCustomers: searchCustomersReducer,
});

const middlewares = [
  createLogicMiddleware([
    addCustomerToSaleLogic,
    addDiscountLogic,
    clearDiscountsLogic,
    fetchContextLogic,
    fetchDiscountsLogic,
    getCustomerLogic,
    removeCustomerFromSaleLogic,
    removeDiscountLogic,
    removeDiscountsLogic,
    searchCustomersLogic,
    createLoyaltyAccountLogic,
  ] as Logic[]),
];

const middlewareEnhancer = applyMiddleware(...middlewares);

const enhancers = [middlewareEnhancer];
const composedEnhancers = composeWithDevTools(...enhancers);

export const store = createStore(rootReducer, composedEnhancers);

export type AppState = ReturnType<typeof store.getState>;
